export const apiKeyReferenceDocLink = `/cloud/auth/api-keys`;
export const oauth2ReferenceDocLink = `/cloud/auth/oauth2-overview`;

export const getDownloadSwaggerJsonUrl = (pathname: string) => {
  // NOTE(jcountryman,01/06/25): Regex matches and strips out the country and
  // language code from the url
  // examples:
  // https://create.roblox.com/docs/cloud/legacy/accountsettings/v1
  // https://create.roblox.com/docs/id-id/cloud/legacy/accountsettings/v1
  // should have download links: https://prod.docsiteassets.roblox.com/assets/en-us/cloud/legacy/accountsettings/v1.json
  if (!pathname.includes('/cloud/legacy/')) {
    return '';
  }
  const docsLangRegex = /\/docs(\/[a-z]{2}-[a-z]{2})?/i;
  const filepath = pathname.replace(docsLangRegex, '');
  const fileUrl = `${process.env.contentBasePath}assets/en-us${filepath}.json`;
  return fileUrl;
};

export const getOperationTagId = (tag: string): string => tag.split(/\s+/).join('-');

export const removeHttps = (url: string): string => url.replace(/^https?:\/\//, '');

const cloudV1Map: { [key: string]: string } = {
  assets: '/reference/cloud/assets/v1',
  datastores: '/reference/cloud/datastores-api/v1',
  'ordered-data-stores': '/reference/cloud/datastores-api/ordered-v1',
  // note these keys have trailing slashes
  'messaging-service/': '/reference/cloud/messaging-service/v1',
  'universes/': '/reference/cloud/universes-api/v1',
};

export const getHrefForViewAllLink = (server: string, version: string): string => {
  const serverWithoutHttps = removeHttps(server);
  if (serverWithoutHttps.endsWith('.roblox.com')) {
    const subdomain = removeHttps(serverWithoutHttps).split('.')[0];
    return `/cloud/legacy/${subdomain}/${version}`;
  }
  if (serverWithoutHttps.includes('legacy')) {
    return `/cloud/legacy/${serverWithoutHttps.split('legacy')[1].replace(/-/g, '')}/${version}`;
  }
  if (serverWithoutHttps.startsWith('apis.roblox.com')) {
    const key = serverWithoutHttps.split('apis.roblox.com/')[1];
    if (cloudV1Map[key]) {
      return cloudV1Map[key];
    }
  }
  return ``;
};
